module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.8a11946f.jpeg";